import CloseIcon from '@mui/icons-material/Close';
import {
  Breakpoint,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  DialogProps as MuiDialogProps,
  Paper,
  PaperProps,
  Typography,
} from '@mui/material';
import React, { FC, ReactElement, useMemo } from 'react';
import Draggable from 'react-draggable';

type ModalProps = MuiDialogProps & {
  actions?: ReactElement;
  fullWidth?: boolean;
  maxWidth?: false | Breakpoint;
  titleElement?: ReactElement;
  id?: string;
};

const getPaperComponent = (id: string) => {
  const DraggablePaper: FC<PaperProps> = props => {
    const ref = React.useRef(null);
    return (
      <Draggable nodeRef={ref} handle={`#${draggableTitleId}`} cancel='[class*="MuiDialogContent-root"]'>
        <Paper ref={ref} {...props} data-cy={id} />
      </Draggable>
    );
  };
  return DraggablePaper;
};

const draggableTitleId = 'draggable-dialog-title';

export const Modal: FC<ModalProps> = ({
  open,
  children,
  onClose,
  title,
  actions,
  maxWidth,
  scroll,
  fullWidth = true,
  titleElement,
  sx,
  id = '',
}) => {
  const PaperComponent = useMemo(() => getPaperComponent(id), [id]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      sx={sx}
      PaperComponent={PaperComponent}
      aria-labelledby={draggableTitleId}
    >
      <DialogTitle style={{ cursor: 'move' }} id={draggableTitleId}>
        {titleElement ? (
          titleElement
        ) : (
          <Typography
            variant="h2"
            component="span"
            title={title}
            sx={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}
          >
            {title}
          </Typography>
        )}
        {onClose && (
          <IconButton onClick={event => onClose(event, 'escapeKeyDown')} data-cy="modal_close">
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>{children}</DialogContent>
      {actions !== undefined && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
};
